import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import DeliverableTasks from '../deliverable_tasks/DeliverableTasks';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';

// Project-level Tasks tab — tasks directly on the project (no deliverableId).
// taskProjectMetrics is server-computed on the project record and feeds the
// "Task List (2/5)" header; the list itself only holds one page.
const ProjectTasksTabPage = ({ match, taskMetrics }) => (
	<div className="border-0 border-t border-solid border-owgray bg-white p-6">
		<DeliverableTasks projectId={match.params.id} metrics={taskMetrics} />
	</div>
);

const mapStateToProps = (state, ownProps) => ({
	taskMetrics: nullSafeGet(
		'taskProjectMetrics',
		getEntityById(nullSafeGet('match.params.id', ownProps), state.projects)
	),
});

export default withRouter(connect(mapStateToProps)(ProjectTasksTabPage));
